import { render, staticRenderFns } from "./Campanha2.vue?vue&type=template&id=1b54ff0a"
import script from "./Campanha2.vue?vue&type=script&lang=js"
export * from "./Campanha2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports